import { useState } from 'react'

export const RewardsTabs = {
  MANAGED_PORTFOLIOS: 'managed-portfolios',
  DISCOVER: 'discover',
}

type RewardsTabs = (typeof RewardsTabs)[keyof typeof RewardsTabs]

export const useRewardsTabs = () => {
  const [activeTab, setActiveTab] = useState<RewardsTabs>(RewardsTabs.MANAGED_PORTFOLIOS)

  const handleChangeTab = (tab: RewardsTabs) => {
    setActiveTab(tab)
  }

  return {
    activeTab,
    handleChangeTab,
  }
}
